import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  createField,
  createValidateObject,
  getForm,
  storeRecoveryFieldValues,
  storeSetFieldsErrors,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';

import {
  createRequestState,
  setRequestStateInProgress,
  setRequestStateFinish
} from '../../../../utils/reducerHalpers/requestState';

import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';
import { getItemFromRefList } from '../../../main/reducers/static/states/referenceLists/reducer';

const INIT_STATE = 'INIT_STATE';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const REQUEST_RECOVERY_FORM = 'REQUEST_RECOVERY_FORM';
const RECOVERY_FORM_FIELDS = 'RECOVERY_FORM_FIELDS';
const SEND_REQUEST = 'SEND_REQUEST';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const CHANGE_FIELD_NOTICE_SUBSCRIBE = 'CHANGE_FIELD_NOTICE_SUBSCRIBE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'notice_subscribe',
          title: 'Настройка уведомлений',
          value: [],
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_IN_PROGRESS):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, REQUEST_RECOVERY_FORM):
        return state;
      case createActionName(name, RECOVERY_FORM_FIELDS):
        return storeRecoveryFieldValues(state, action.payload);
      case createActionName(name, SEND_REQUEST):
        return state;
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_NOTICE_SUBSCRIBE): {
        return storeSetFieldValue(state, 'notice_subscribe', action.payload);
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const requestRecoveryForm = (parentName, payload) => ({
  type: createActionName(parentName, REQUEST_RECOVERY_FORM),
  payload
});
export const recoveryFormFields = (parentName, payload) => ({
  type: createActionName(parentName, RECOVERY_FORM_FIELDS),
  payload
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});
export const setErrors = (parentName, payload) => ({
  type: createActionName(parentName, SET_ERRORS),
  payload
});
export const clearAllErrors = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

export const changeFieldNoticeSubscribe = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_NOTICE_SUBSCRIBE),
  payload
});

// SELECTORS
export const selectFormBody = (state, parentName) =>
  getForm(getState(state, parentName));
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');
export const selectFieldNoticeSubscribe = (state, parentName) =>
  Immutable.asMutable(
    _.get(getState(state, parentName), 'fields.notice_subscribe'),
    { deep: true }
  );

export const selectEventsUserNoticeTypesCategory = state =>
  getItemFromRefList(state, 'eventsUserNoticeTypesCategory');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/common/reducers/userNoticesSubscribeForm.js